import MainContainer from "../../components/container/MainContainer";

const MonthlyFinancialReport = () => {
  return <MainContainer>MonthlyFinancialReport</MainContainer>;
};

export default MonthlyFinancialReport;
